/**
 * Georgian lari.
 */
export var GEL = {
  code: 'GEL',
  base: 10,
  exponent: 2
};